import { useState } from "react";
import { MeetingCalendar } from "@acto/taskpane/field-sales-2/components/patterns/MeetingCalendar";
import { useNearbyCustomersFlow } from "@acto/taskpane/field-sales-2/components/patterns/NearbyCustomers";
import { usePlanMeetingFlow } from "@acto/taskpane/field-sales-2/components/patterns/PlanMeetingSheet";

export function HomeMeetingCalendar() {
  const { openPicker, openPlanOnDay, openPickerOnDay, sheets } = usePlanMeetingFlow();
  const [selectedDay, setSelectedDay] = useState<Date | null>(null);
  const nearby = useNearbyCustomersFlow({ selectedDay, openPlanOnDay, openPickerOnDay });

  return (
    <>
      <MeetingCalendar
        view="week"
        onAddMeeting={openPicker}
        onSelectedDateChange={setSelectedDay}
        onDayMeetingsChange={nearby.onDayMeetingsChange}
        dayFooter={nearby.entry}
      />
      {nearby.sheet}
      {sheets}
    </>
  );
}
